import React from 'react';
import TokenIcon from './TokenIcon';

const TokenCardHeader = ({ token }) => (
  <div className="aridhia-card-header-content w-100">
    <span title={token.name}>
      <TokenIcon active={token.active} jwt={token.jwt} />
      {token.name}
    </span>
  </div>
);

export default TokenCardHeader;
